// extracted by mini-css-extract-plugin
export default {"EledoCreateRoot":"EledoCreateRoot_EledoCreateRoot__q+ieP","content-wrapper":"EledoCreateRoot_content-wrapper__h5CKY"};